import { BRAND } from "constants/brand";
import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";

import { Form } from "react-bootstrap";

import { CSSTransition } from "react-transition-group";
import { Ring } from "@uiball/loaders";
import Select from "components/Ui/SelectField/SelectField";
import useArea from "hooks/useArea";
import useUser from "hooks/useUser";

const AddAreas = (props) => {
    const form = useRef();
    const nodeRef = useRef();

    const { loading, addAreas } = useUser();
    const [vendor, setVendor] = useState();
    const [newAreas, setAreas] = useState([]);
    const [selectedAreas, setSelectedAreas] = useState([]);
    const [city, selectCity] = useState("");
    const { areas } = useArea();

    useEffect(() => {
        if (areas && city !== "") {
            setAreas(
                areas
                    .filter((a) => +a.cityId === +city)
                    .map((area) => {
                        return { value: area.id, label: area.name };
                    }),
            );
        } else {
            setAreas([]);
        }
    }, [areas, city]);

    const handleChangeAreas = (selectedOptions) => {
        setSelectedAreas(selectedOptions);
    };

    const submitHandler = async (e) => {
        e.preventDefault();

        const areas = [];

        selectedAreas.forEach((area) => {
            areas.push(+area.value);
        });
        console.log(props.selectedUsers);

        try {
            const response = await addAreas({
                deliveryIds: props.selectedUsers,
                areas: areas,
            });
            // Assuming `response` contains information to check if the operation succeeded

            props.showMessage("success", "تم التعيين", "تم تعيين المناطق للسائقين المحددين");
            props.close(); // Uncomment if you need to close a modal or similar
        } catch (err) {
            console.error("Error adding vendor:", err);
            props.showMessage("error", "هناك خطأ", err || "حدث خطأ غير متوقع");
        }
    };

    return (
        <>
            <div className={`model ${props.show ? "model-show" : ""}`} onClick={props.close}>
                <CSSTransition
                    mountOnEnter
                    unmountOnExit
                    nodeRef={nodeRef}
                    in={props.show}
                    timeout={400}
                    classNames="show"
                >
                    <div
                        className="addItem"
                        style={{ overflow: "visible" }}
                        ref={nodeRef}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {loading ? (
                            <div className="loading-spinner center">
                                <Ring size={40} lineWeight={5} speed={2} color={BRAND} />
                            </div>
                        ) : null}
                        <div
                            className="head center"
                            style={{
                                borderTopLeftRadius: "10px",
                                borderTopRightRadius: "10px",
                            }}
                        >
                            <h5>تعيين المناطق للسائقين المحددين</h5>
                            <FontAwesomeIcon icon={faClose} onClick={props.close} />
                        </div>
                        <Form className="form" ref={form} onSubmit={submitHandler}>
                            <Form.Group className="mb-3" controlId="status">
                                <Form.Label>
                                    المدينه<span>*</span>
                                </Form.Label>
                                <Form.Select
                                    defaultValue=""
                                    onChange={(e) => {
                                        selectCity(e.target.value);
                                    }}
                                >
                                    <option value="" disabled>
                                        اختر المدينة
                                    </option>
                                    {props.cities?.map((c) => (
                                        <option key={c.id} value={c.id}>
                                            {c.name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>

                            <Form.Group className="mb-3" controlId="status">
                                <Form.Label>
                                    المناطق<span style={{ color: "red" }}>*</span>
                                </Form.Label>
                                <Select
                                    value={selectedAreas}
                                    options={newAreas}
                                    placeholder={"المناطق"}
                                    isMulti
                                    onChange={handleChangeAreas}
                                />
                            </Form.Group>

                            {/* The endpoint DELETES every existing DeliveryArea row
                                for the selected drivers before it writes these, so
                                this is a replace and not an addition. It has to say
                                so: a driver left with the wrong zones stops being
                                offered orders, and nothing on this screen would
                                show that it had happened. */}
                            <div className="form-warning">
                                ⚠️ سيتم استبدال مناطق السائقين المحددين بالكامل، وليس الإضافة إليها.
                            </div>

                            <div className="buttons">
                                <button className="cancel" onClick={props.close} type="button">
                                    إلغاء
                                </button>
                                <button className="button" type="submit">
                                    تعيين المناطق
                                </button>
                            </div>
                        </Form>
                    </div>
                </CSSTransition>
            </div>
        </>
    );
};
export default AddAreas;
